import { useMutation, useQuery } from '@tanstack/react-query';
import { MRT_RowSelectionState } from 'mantine-react-table';
import { useEffect, useState } from 'react';

import { PlotsDataGrid } from '../../components/plots-data-grid/plots-data-grid';
import { SynthesisHeader } from '../../components/synthesis-header/synthesis-header';
import { dashboardApi } from '../../data-access/api/dashboard.api';

import styles from './page.module.css';

import { FORM_STATUS } from '@advices/data-access';
import { useColFilters, useSharedQueries } from '@data-access';
import { FullMainHeight } from '@ui';

export function SynthesisPage() {
  const [filters] = useColFilters('dashboardSynthesis');
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [computationRequestId, setComputationRequestId] = useState<
    number | null
  >(null);

  const exportSynthesis = useMutation({
    mutationFn: dashboardApi.exportSynthesis,
    onSuccess: (data) => {
      setComputationRequestId(data.instance_id);
    },
  });
  const downloadSynthesis = useMutation({
    mutationFn: dashboardApi.downloadExport,
  });
  const sharedQueries = useSharedQueries();
  const computationRequest = useQuery({
    ...sharedQueries.computationRequest({ id: computationRequestId! }),
    enabled: computationRequestId !== null,
  });

  const handleDownloadRecaps = () => {
    if (rowSelection.all) {
      exportSynthesis.mutate({
        ids: [],
        all: true,
        selectedFilters: filters,
      });
    } else {
      const ids = Object.keys(rowSelection).map((id) => Number(id));
      exportSynthesis.mutate({
        ids,
      });
    }
  };

  useEffect(() => {
    if (computationRequest.data?.status === FORM_STATUS.FINISHED) {
      downloadSynthesis.mutate({
        id: computationRequest.data.id,
      });
      setComputationRequestId(null);
    }
  }, [computationRequest.data, downloadSynthesis]);

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <SynthesisHeader
          onExport={handleDownloadRecaps}
          preparingSynthesis={
            computationRequest.data?.status === FORM_STATUS.PENDING ||
            exportSynthesis.isPending
          }
        />
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <PlotsDataGrid
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
        />
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

export default SynthesisPage;
